import ProductsSlider from './ProductsSlider';

export default ProductsSlider;
